import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { NavTab } from 'types/baseTypes';
import { findActiveSubTab } from 'utils/commonUtils';
import SideNavTab from './NavTab';
import { selectHoverState, selectMenuState } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

interface NavSectionProps {
  isBottomBar?: boolean;
  navList: NavTab[];
  onNavTabClick: (tab: NavTab) => void;
  activeTab: NavTab;
  className?: string;
  onSubTabClick: (tab: NavTab) => void;
}

const NavSection: FC<NavSectionProps> = ({
  isBottomBar = false,
  navList,
  onNavTabClick,
  activeTab,
  className,
  onSubTabClick
}) => {
  const location = useLocation();
  const isMenuActive = useAppSelector(selectMenuState);
  const isHoverActive = useAppSelector(selectHoverState);

  const activeSubTab = activeTab.hasChildTabs && findActiveSubTab(location.pathname);

  const isActiveSubTab = (subtab: NavTab) => {
    if (!activeSubTab) {
      return false;
    }
    return activeSubTab.path === subtab.path;
  };

  const hasActiveChildTab = (tab: NavTab) => {
    if (!tab.hasChildTabs) {
      return false;
    }
    return tab.childTabs?.some(childTab => isActiveSubTab(childTab));
  };

  return (
    <div className={`${className} space-y-2 py-5`}>
      {navList.map(tab => {
        return (
          <div
            key={tab.key}
            className={
              hasActiveChildTab(tab) && !isMenuActive && !isHoverActive ? 'rounded-md border border-secondaryBtn' : ''
            }>
            <SideNavTab
              tab={tab}
              onNavTabClick={onNavTabClick}
              isBottomBar={isBottomBar}
              activeTab={activeTab}
              key={tab.key}
              hasActiveChildTab={hasActiveChildTab(tab)}
            />
            {tab?.hasChildTabs &&
              activeTab.key === tab.key &&
              tab.childTabs.map((subTab, index) => (
                <div key={subTab.key + index}>
                  <SideNavTab
                    tab={subTab}
                    onNavTabClick={onSubTabClick}
                    isBottomBar={isBottomBar}
                    activeTab={activeTab}
                    isActiveSubTab={isActiveSubTab(subTab)}
                    subTabClassname="pl-10"
                  />
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
};

export default NavSection;
